import { getContext, put, call, select, takeEvery } from 'redux-saga/effects';
import { Action } from 'redux';
import { ApolloError } from 'apollo-client';
import { FormAction as BaseFormAction, SubmissionError } from 'redux-form';
import { SagaContext } from '../../../../types/common';
import { languageSelector } from '../../../../selectors/app';
import { sessionId } from '../../selectors';
import { routine, actions } from './actions';
import { FormData } from './constraints';
import { Props } from './index';
import * as mutation from './mutation.gql';
import { LoginAndPasswordVariables } from './__generated__/LoginAndPassword';
import { Services } from 'init/services';
import { getFormErrors } from '../../../../utils/formatError';

interface FormAction extends BaseFormAction {
  payload: {
    values: FormData;
    props: Props;
  };
}

export default function* saga(next: Action) {
  const apolloClient: Services[SagaContext.ApolloClient] = yield getContext(
    SagaContext.ApolloClient
  );

  yield takeEvery(
    routine.TRIGGER,
    function* ({
      payload: {
        values: { login, password },
      },
    }: FormAction) {
      const variables: LoginAndPasswordVariables = {
        sessionId: yield select(sessionId),
        locale: yield select(languageSelector),
        login: login.trim(),
        password,
      };

      try {
        yield call(apolloClient.mutate, { mutation, variables });
        yield put(routine.success());
        yield put(actions.save(login, password));
        yield put(next);
      } catch (e: ApolloError | any) {
        const errors = getFormErrors(e);
        yield put(routine.failure(new SubmissionError<FormData>(errors)));
      }
    }
  );
}
